import React from "react";

import { ContainerRouter } from "./styles";

import RecoverOption from "./RecoverOptions";
import OnboardStep from "../OnboardStep";

import ConfirmPinCodePhone from "./ConfirmPinCodePhone";
import ConfirmPinCodeEmail from "./ConfirmPinCodeEmail";
import ChangePassword from "./ChangePassword";
import Support from "./Support";

const OnboardForgotPassword = (props) => {
	return (
		<ContainerRouter>
			<OnboardStep />
			<Pages {...props.location.state} />
			<Support />
		</ContainerRouter>
	);
};

const Pages = (flowPage) => {
	const pages = {
		"recover-data-option": () => <RecoverOption />,
		"recover-confirm-pin-code-phone": () => <ConfirmPinCodePhone {...flowPage} />,
		"recover-confirm-pin-code-email": () => <ConfirmPinCodeEmail {...flowPage} />,
		"recover-account": () => <ChangePassword />,
		default: () => <></>,
	};

	const paths = flowPage.param ? flowPage.param : "recover-data-option";

	return (pages[paths] || pages.default)();
};

export default OnboardForgotPassword;
